import { z } from 'zod';

export const dashboardNameSchema = z.object({
  name: z
    .string()
    .min(1, 'نام داشبورد الزامی است')
    .min(2, 'نام داشبورد باید حداقل ۲ کاراکتر باشد')
    .max(100, 'نام داشبورد نباید بیشتر از ۱۰۰ کاراکتر باشد'),
});
